var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0026 24.7331L11.1457 23.8845L23.1431 12.0052L24 12.8537L12.0026 24.7331Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8544 23.8845L11.9974 24.733L1.25912e-05 12.8537L0.85697 12.0051L12.8544 23.8845Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4868 0.733086L12.4868 23.5331L11.2748 23.5331L11.2748 0.733086L12.4868 0.733086Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMDAyNiAyNC43MzMxTDExLjE0NTcgMjMuODg0NUwyMy4xNDMxIDEyLjAwNTJMMjQgMTIuODUzN0wxMi4wMDI2IDI0LjczMzFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNMTIuODU0NCAyMy44ODQ1TDExLjk5NzQgMjQuNzMzTDEuMjU5MTJlLTA1IDEyLjg1MzdMMC44NTY5NyAxMi4wMDUxTDEyLjg1NDQgMjMuODg0NVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuNDg2OCAwLjczMzA4NkwxMi40ODY4IDIzLjUzMzFMMTEuMjc0OCAyMy41MzMxTDExLjI3NDggMC43MzMwODZMMTIuNDg2OCAwLjczMzA4NloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";
export { ForwardRef as ReactComponent };